import "../../shimmer.css";

const CategoryButtonShimmer = () => {
  return (
    <button
      className={`animate-pulse-gradient h-[30px] md:h-[35px] px-4 text-transparent min-w-max rounded-full`}
    >
      <span>Category name</span>
    </button>
  );
};

export default CategoryButtonShimmer;
